import { Text } from '@hudl/uniform-ui-components';
import React from 'react';
import * as styles from './styles.scss';

interface LoginInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label?: string;
  value?: string;
  qaId?: string;
  innerRef?: React.Ref<HTMLInputElement>;
  helpText?: string;
}

// Intentionally not using Uniform's <Input />
// We want to have a special input for login - notably with a white background
const LoginInput = (props: LoginInputProps) => {
  const { className, label, qaId, innerRef, helpText, ...other } = props;

  const newId = other.id;
  const newName = other.name;

  return (
    <div className={className ?? ''}>
      {label && (
        <label className="uni-form__label" htmlFor={newId} data-qa-id={`${qaId}-label`}>
          {label}
        </label>
      )}

      <input
        {...other}
        id={newId}
        name={newName}
        type={other.type}
        className={styles.loginInput}
        aria-describedby={newName + 'Help'}
        data-qa-id={qaId}
        ref={innerRef}
      />

      {helpText && (
        <Text level="micro" color="subtle" className="uni-form__help-message" qaId={`${qaId}-help-text`}>
          <span id={newName + 'Help'}>{helpText}</span>
        </Text>
      )}
    </div>
  );
};

export default LoginInput;
